var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCharge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "charge_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#charge_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.667 36.667V6.222h5V3.333h6.666v2.89h5V20.75c-2.555.01-4.736.914-6.541 2.715-1.806 1.801-2.709 3.989-2.709 6.563 0 1.315.255 2.541.764 3.68a9.211 9.211 0 0 0 2.083 2.959H11.667Zm2.778-23.222h11.11V9h-11.11v4.445ZM27.5 36.472v-4.805h-3.611l5.278-8.112v4.778h3.61l-5.277 8.14Z"
}))));
export default SvgCharge;